

<script>
/* eslint-disable no-console */
/* eslint-disable no-unreachable */
import Layout from "../layouts/auth";
import {
  authMethods,
  notificationMethods,
} from "@/state/helpers";

import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

/**
 * Login component
 * test2@pyhash.com
 * testpro123
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      isLoading: false,
    };
  },
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    gotoLogin(){
      return (
        this.logIn({email: this.email,password: this.password})
          // eslint-disable-next-line no-unused-vars
          .then((token) => {
            this.tryingToLogIn = false;
            this.isAuthError = false;
            // Redirect to the originally requested page, or to the home page
            this.$router.push({name: "default"});
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            this.tryingToLogIn = false;
            this.authError = error ? error : "";
            this.isAuthError = true;
            this.isLoading = false;
          })
      );
    },
    tryToLogIn() {
      // stop here if form is invalid
      this.$v.$touch();
this.submitted = true;
      if (this.$v.$invalid) {
        return;
      } else {
          this.tryingToLogIn = true;
          this.authError = null;
          
          this.isLoading = true;
          setTimeout(() => {
            this.gotoLogin()
          }, 100);
      }
    },
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Hệ thống quản lý đơn hàng POS</h5>
                  <span>Đăng nhập để tiếp tục.</span>
                </div>
          </div>
          <div class="card-body pt-3">
            <b-alert v-model="isAuthError" variant="danger" dismissible>{{ authError }}</b-alert>
            <div v-if="notification.message" :class="'alert ' + notification.type">
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3"
                id="input-group-1"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Email"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Tài khoản là bắt buộc.</span>
                  <span v-if="!$v.email.email">Tài khoản không đúng.</span>
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="input-group-2"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Mật khẩu"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Mật khẩu là bắt buộc
                </div>
              </b-form-group>
              <div class="mt-3 d-grid">
                <b-button type="submit" variant="primary" class="btn-block"><i v-if="isLoading" class="fas fa-spinner fa-spin"></i> Đăng nhập</b-button
                >
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="text-center">
          <small><i>© {{ new Date().getFullYear() }} TGA</i></small>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
